import script from "./SelectSimple.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectSimple.vue?vue&type=script&setup=true&lang=ts"

import "./SelectSimple.vue?vue&type=style&index=0&id=460a8263&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-460a8263"]])

export default __exports__